import { defineMessages } from 'react-intl';

export const dentalConsultationMessages = defineMessages({
  pageTitle: {
    id: 'dentalConsultation.pageTitle',
    defaultMessage: 'Dental Consultation',
  },
  tabSummary: {
    id: 'global.summary',
    defaultMessage: 'Summary',
  },
  tabEvaluation: {
    id: 'global.evaluation',
    defaultMessage: 'Evaluation',
  },
  tabFollowUp: {
    id: 'dentalConsultation.tab.followUp',
    defaultMessage: 'Follow up',
  },
  tabLiteratureReview: {
    id: 'dentalConsultation.tab.literatureReview',
    defaultMessage: 'Literature Review',
  },
  consultationNotFound: {
    id: 'dentalConsultation.error.notFound',
    defaultMessage: 'Consultation not found',
  },
  consultationNotFoundDescription: {
    id: 'dentalConsultation.error.notFoundDescription',
    defaultMessage: 'The requested consultation could not be loaded.',
  },
  doctorDefaultName: {
    id: 'global.doctor',
    defaultMessage: 'Doctor',
  },
  copyError: {
    id: 'dentalConsultation.copyError',
    defaultMessage: 'Failed to copy to clipboard',
  },
  saveButton: {
    id: 'global.save',
    defaultMessage: 'Save',
  },
  editButton: {
    id: 'global.edit',
    defaultMessage: 'Edit',
  },
  copiedMessage: {
    id: 'global.copied',
    defaultMessage: 'Copied',
  },
  copyButton: {
    id: 'global.copy',
    defaultMessage: 'Copy',
  },
  summaryTitle: {
    id: 'global.summary',
    defaultMessage: 'Summary',
  },
  evaluationTitle: {
    id: 'global.evaluation',
    defaultMessage: 'Evaluation',
  },
  followUpTitle: {
    id: 'dentalConsultation.followUpTitle',
    defaultMessage: 'Follow up',
  },
  transcriptTitle: {
    id: 'dentalConsultation.transcriptTitle',
    defaultMessage: 'Transcript',
  },
  audioNotSupported: {
    id: 'dentalConsultation.audioNotSupported',
    defaultMessage: 'Your browser does not support the audio element.',
  },
  recordingTitle: {
    id: 'dentalConsultation.recordingTitle',
    defaultMessage: 'Recording {index}',
  },
  recordingProcessing: {
    id: 'dentalConsultation.recordingProcessing',
    defaultMessage: 'Audio is being processed',
  },
  noTranscriptAvailable: {
    id: 'dentalConsultation.noTranscriptAvailable',
    defaultMessage: 'No transcript available',
  },
  scoreLabel: {
    id: 'dentalConsultation.scoreLabel',
    defaultMessage: 'Score: {score}',
  },
  noEvaluationAvailable: {
    id: 'dentalConsultation.noEvaluationAvailable',
    defaultMessage: 'No evaluation available',
  },
  evaluationDataRaw: {
    id: 'dentalConsultation.evaluationDataRaw',
    defaultMessage: 'Evaluation Data (Raw)',
  },
  evaluationParseError: {
    id: 'dentalConsultation.evaluationParseError',
    defaultMessage: 'Error parsing evaluation data',
  },
  noSummaryAvailable: {
    id: 'dentalConsultation.noSummaryAvailable',
    defaultMessage: 'No summary available',
  },
  noLiteratureReviewAvailable: {
    id: 'dentalConsultation.noLiteratureReviewAvailable',
    defaultMessage: 'No literature review available',
  },
  noFollowUpAvailable: {
    id: 'dentalConsultation.noFollowUpAvailable',
    defaultMessage: 'No follow-up data available',
  },

  // Summary section titles
  summaryGeneral: {
    id: 'dentalConsultation.summary.general',
    defaultMessage: 'General',
  },
  summaryGeneralInformation: {
    id: 'dentalConsultation.summary.generalInformation',
    defaultMessage: 'General Information',
  },
  summarySubjective: {
    id: 'dentalConsultation.summary.subjective',
    defaultMessage: 'Subjective',
  },
  summaryObjective: {
    id: 'dentalConsultation.summary.objective',
    defaultMessage: 'Objective',
  },
  summaryAssessment: {
    id: 'dentalConsultation.summary.assessment',
    defaultMessage: 'Assessment',
  },
  summaryPlan: {
    id: 'dentalConsultation.summary.plan',
    defaultMessage: 'Plan',
  },
  summaryPatientName: {
    id: 'dentalConsultation.summary.patientName',
    defaultMessage: 'Patient Name',
  },
  summaryPatientDateOfBirth: {
    id: 'dentalConsultation.summary.patientDateOfBirth',
    defaultMessage: 'Patient Date of Birth',
  },
  summaryDoctorName: {
    id: 'dentalConsultation.summary.doctorName',
    defaultMessage: 'Doctor Name',
  },
  summaryChiefComplaint: {
    id: 'dentalConsultation.summary.chiefComplaint',
    defaultMessage: 'Chief Complaint',
  },
  summaryHistoryPresentIllness: {
    id: 'dentalConsultation.summary.historyPresentIllness',
    defaultMessage: 'History of Present Illness',
  },
  summaryHistory: {
    id: 'dentalConsultation.summary.history',
    defaultMessage: 'History',
  },
  summaryReviewSymptoms: {
    id: 'dentalConsultation.summary.reviewSymptoms',
    defaultMessage: 'Review of Symptoms',
  },
  summaryMedications: {
    id: 'dentalConsultation.summary.medications',
    defaultMessage: 'Medications',
  },
  summaryClinicalExaminations: {
    id: 'dentalConsultation.summary.clinicalExaminations',
    defaultMessage: 'Clinical Examinations',
  },
  summaryImagingResults: {
    id: 'dentalConsultation.summary.imagingResults',
    defaultMessage: 'Imaging Results',
  },
  summaryDiagnosis: {
    id: 'dentalConsultation.summary.diagnosis',
    defaultMessage: 'Diagnosis',
  },
  summaryDentalHygieneDiagnosis: {
    id: 'dentalConsultation.summary.dentalHygieneDiagnosis',
    defaultMessage: 'Dental Hygiene Diagnosis',
  },
  summaryProceduresPerformed: {
    id: 'dentalConsultation.summary.proceduresPerformed',
    defaultMessage: 'Procedures Performed',
  },
  summaryMedicationsGiven: {
    id: 'dentalConsultation.summary.medicationsGiven',
    defaultMessage: 'Medications Given',
  },
  summaryEducationProvided: {
    id: 'dentalConsultation.summary.educationProvided',
    defaultMessage: 'Education Provided',
  },
  summaryReferralsGiven: {
    id: 'dentalConsultation.summary.referralsGiven',
    defaultMessage: 'Referrals Given',
  },
  summaryFollowUpInstructions: {
    id: 'dentalConsultation.summary.followUpInstructions',
    defaultMessage: 'Follow-up Instructions',
  },
  summaryContact: {
    id: 'dentalConsultation.summary.contact',
    defaultMessage: 'Contact',
  },
  summaryInterview: {
    id: 'dentalConsultation.summary.interview',
    defaultMessage: 'Interview',
  },

  // Evaluation section titles
  evaluationConsultationQualityAssessment: {
    id: 'dentalConsultation.evaluation.consultationQualityAssessment',
    defaultMessage: 'Consultation Quality Assessment',
  },
  evaluationDocumentationQuality: {
    id: 'dentalConsultation.evaluation.documentationQuality',
    defaultMessage: 'Documentation Quality',
  },
  evaluationClinicalReasoning: {
    id: 'dentalConsultation.evaluation.clinicalReasoning',
    defaultMessage: 'Clinical Reasoning',
  },
  evaluationProfessionalCommunication: {
    id: 'dentalConsultation.evaluation.professionalCommunication',
    defaultMessage: 'Professional Communication',
  },
  evaluationOverallQuality: {
    id: 'dentalConsultation.evaluation.overallQuality',
    defaultMessage: 'Overall Quality',
  },
  evaluationCompleteness: {
    id: 'dentalConsultation.evaluation.completeness',
    defaultMessage: 'Completeness',
  },
  evaluationAccuracy: {
    id: 'dentalConsultation.evaluation.accuracy',
    defaultMessage: 'Accuracy',
  },
  evaluationRelevance: {
    id: 'dentalConsultation.evaluation.relevance',
    defaultMessage: 'Relevance',
  },
  evaluationClarity: {
    id: 'dentalConsultation.evaluation.clarity',
    defaultMessage: 'Clarity',
  },
  evaluationOrganization: {
    id: 'dentalConsultation.evaluation.organization',
    defaultMessage: 'Organization',
  },
  evaluationPresentation: {
    id: 'dentalConsultation.evaluation.presentation',
    defaultMessage: 'Presentation',
  },
  evaluationJustification: {
    id: 'dentalConsultation.evaluation.justification',
    defaultMessage: 'Justification',
  },
  evaluationNegotiation: {
    id: 'dentalConsultation.evaluation.negotiation',
    defaultMessage: 'Negotiation',
  },
  evaluationClosure: {
    id: 'dentalConsultation.evaluation.closure',
    defaultMessage: 'Closure',
  },
  evaluationTranscriptAnalysis: {
    id: 'dentalConsultation.evaluation.transcriptAnalysis',
    defaultMessage: 'Transcript Analysis',
  },
  evaluationContact: {
    id: 'dentalConsultation.evaluation.contact',
    defaultMessage: 'Contact',
  },
  evaluationInterview: {
    id: 'dentalConsultation.evaluation.interview',
    defaultMessage: 'Interview',
  },

  // Follow-up section titles
  followUpCommunication: {
    id: 'dentalConsultation.followUp.followUpCommunication',
    defaultMessage: 'Follow-up Communication',
  },
  followUpLetter: {
    id: 'dentalConsultation.followUp.followUpLetter',
    defaultMessage: 'Follow-up Letter',
  },
  followUpPatientCommunication: {
    id: 'dentalConsultation.followUp.patientCommunication',
    defaultMessage: 'Patient Communication',
  },

  // Literature review
  literatureReferences: {
    id: 'dentalConsultation.literatureReferences',
    defaultMessage: 'References',
  },
  reportRecording: {
    id: 'dentalConsultation.status.recording',
    defaultMessage: 'Recording in progress',
  },
  reportProcessing: {
    id: 'dentalConsultation.status.processing',
    defaultMessage: 'Transcription is being processed',
  },
  executiveSummaryTitle: {
    id: 'dentalConsultation.summary.executiveSummary',
    defaultMessage: 'Executive Summary',
  },
  executiveSummaryProcessing: {
    id: 'dentalConsultation.summary.executiveSummaryProcessing',
    defaultMessage: 'Executive summary is being generated',
  },
  reportFailed: {
    id: 'dentalConsultation.status.failed',
    defaultMessage: 'Report generation failed',
  },
  reportSkipped: {
    id: 'dentalConsultation.status.skipped',
    defaultMessage: 'Recording is too short',
  },
  noSpeechDetectedLabel: {
    id: 'dentalConsultation.status.noSpeechDetected',
    defaultMessage: 'No speech detected',
  },
  noSpeechDetectedMessage: {
    id: 'dentalConsultation.noSpeechDetected.message',
    defaultMessage:
      'No speech detected in this recording. Please check that your microphone is connected, unmuted, and selected as the input device, then record again.',
  },
  recordingInterruptedLabel: {
    id: 'dentalConsultation.status.recordingInterrupted',
    defaultMessage: 'Recording was interrupted',
  },
  recordingInterruptedMessage: {
    id: 'dentalConsultation.recordingInterrupted.message',
    defaultMessage:
      'This summary covers {duration} of recording. Part of the consultation may be missing.',
  },
  regenerateButton: {
    id: 'dentalConsultation.action.regenerate',
    defaultMessage: 'Regenerate',
  },
  regenerateFailed: {
    id: 'dentalConsultation.action.regenerateFailed',
    defaultMessage: 'Failed to regenerate report',
  },
});

export const continueRecordingMessages = defineMessages({
  button: {
    id: 'dentalConsultation.continueRecording.button',
    defaultMessage: 'Continue recording',
  },
  hint: {
    id: 'dentalConsultation.continueRecording.hint',
    defaultMessage:
      'Adding audio updates the summary with the new recording. Other documents are not changed.',
  },
  processing: {
    id: 'dentalConsultation.continueRecording.processing',
    defaultMessage: 'Processing recording…',
  },
  recording: {
    id: 'dentalConsultation.continueRecording.recording',
    defaultMessage: 'Recording in progress…',
  },
});
